import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  chartLegend: {
    width: '220px',
    padding: '20px'
  },
  legendTitle: {
    fontSize: '37px',
    fontWeight: 'bold'
  },
  legendIcon: {
    maxWidth: '30px !important'
  },
  legendItem: {
    fontSize: '13px',
    padding: '5px',
    '&:not(:last-child)': {
      borderBottom: '1px solid #E2EBF6'
    }
  },
  itemName: {
    width: '120px'
  },
  listIcon: {
    minWidth: '30px'
  },
  descriptionWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  chipsHelpIcon: {
    fontSize: '18px',
    top: '-4px',
    marginLeft: '6px'
  }
}));

export default useStyles;
